import {Utilities} from '../../shared/utilities/utilities.model';
import {isBoolean} from 'util';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {DateUtilities} from '../../shared/utilities/date-utilities.model';

export class DeliveryChecks {
	static COD_OWNER_AMSP = 'AMSP';
	static COD_OWNER_SERV = 'SERV';
	static COD_OWNER_FACT = 'FACT';

	static WD_TYPE_DELIVERY_CHECK = 'delivery_check';
	static WD_TYPE_OPTION_CHECK = 'option_check';
    static WD_TYPE_NONE = 'none';
    static REPORTING_NONE_VALUE = 'Nessuno';
    static REPORTING_MISSING_VALUE = 'Mancante';
    static REPORTING_IRREGULAR_VALUE = 'Difforme/non compatibile';
    static REPORTING_NOT_EXPECTED_VALUE = 'Non previsto da allestimento';
    static REPORTING_DAMAGED_VALUE = 'Danneggiato';
    static REPORTING_ORDERED_VALUE = 'Ordinato';
    static REPORTING_RECEIVED_VALUE = 'Ricevuto';

	private updatedStatus: Subject<boolean> = new Subject();
	public update_status: Observable<boolean> = this.updatedStatus.asObservable();

	cod_owner: string;
	wd_type: string;
	is_aftermarket: boolean;
	id: number;
	txt_chassis: string;
	txt_category: string; //il blocco in cui deve finire
	txt_description: string;
	txt_more: string;
	txt_reason_reporting: string;
	txt_reason_notes: string;
	txt_plate?: string;
	check: number;
	flag_active: boolean;
	date_installation: string;
	date_provision: string;
	date_request: string;
	cod_factory: number;
	am_net: number;
	txt_dates_display: string;
	flag_updatable_afterreadysp?: string;
	flag_updatable_afterreadyald?: string;

	insuranceCertificates: any;
	registrationBooks: any;

	private date_alert: string;

	constructor(model?: any) {
		if (model) {
			if (model.wd_type) {
				this.wd_type = model.wd_type;
			}
			this.is_aftermarket = model.is_aftermarket;
			if (model.id) {
				this.id = Number.parseInt(model.id);
			}
			if (model.txt_category) {
				this.txt_category = model.txt_category;
			}
			if (model.txt_chassis) {
				this.txt_chassis = model.txt_chassis;
			}
			if (model.txt_plate) {
				this.txt_plate = model.txt_plate;
			}
			if (model.cod_owner) {
				this.cod_owner = model.cod_owner;
			}
			if (model.txt_description) {
				this.txt_description = model.txt_description;
			}
			if (model.date_installation) {
				this.date_installation = model.date_installation;
			}
			if (model.txt_more) {
				this.txt_more = model.txt_more;
			}

			this.txt_reason_reporting = !Utilities.isVoid(model.txt_reason_reporting) ? model.txt_reason_reporting : '';
			this.txt_reason_notes = !Utilities.isVoid(model.txt_reason_notes) ? model.txt_reason_notes : '';

			if (!Utilities.isVoid(model.check)) {
				this.check = Number.parseInt(model.check);
			}
			if (isBoolean(model.flag_active)) {
				this.flag_active = model.flag_active;
			} else if (!Utilities.isVoid(model.flag_active)) {
				this.flag_active = model.flag_active.toLowerCase() === 'true';
			}
			if (model.date_provision) {
				this.date_provision = model.date_provision;
			}
			if (model.cod_factory) {
				this.cod_factory = Number.parseFloat(model.cod_factory);
			}
			if (model.am_net) {
				this.am_net = Number.parseFloat(model.am_net);
			}
			if (model.txt_dates_display) {
				this.txt_dates_display = model.txt_dates_display;
			}
			if (model.date_request) {
				this.date_request = model.date_request;
			}
			this.flag_updatable_afterreadysp = model.flag_updatable_afterreadysp;
			this.flag_updatable_afterreadyald = model.flag_updatable_afterreadyald;
		}
	}

  isWinterTiresPeriod(): boolean {
    return this.txt_description.trim() === 'Consegna con gomme invernali nel periodo di riferimento' ;
  }

	isDatesDisplayNone(): boolean {
		return !Utilities.isVoid(this.txt_dates_display) &&  this.txt_dates_display === 'none';
	}

	isDeliveryCheck(): boolean {
		return this.wd_type === DeliveryChecks.WD_TYPE_DELIVERY_CHECK;
	}

	isOptionCheck(): boolean {
		return this.wd_type === DeliveryChecks.WD_TYPE_OPTION_CHECK;
	}

	/*showDataInstallation(): boolean {
		return this.wd_type === DeliveryChecks.WD_TYPE_DELIVERY_CHECK || this.showDataProvisionAndRequest()
			|| !Utilities.isVoid(this.txt_dates_display) && this.txt_dates_display === 'none';
	}

	showDataProvisionAndRequest(): boolean {
		return this.wd_type === DeliveryChecks.WD_TYPE_OPTION_CHECK && (!this.txt_dates_display || this.txt_dates_display !== 'none');
	}*/

	isCodOwnerASMP(): boolean {
		return this.cod_owner === DeliveryChecks.COD_OWNER_AMSP;
	}

	isCodOwnerFACT(): boolean {
		return this.cod_owner === DeliveryChecks.COD_OWNER_FACT;
	}

	isCodOwnerSERV(): boolean {
		return this.cod_owner === DeliveryChecks.COD_OWNER_SERV;
	}

	isItemReady(): boolean {
		if (this.check === 0) {
			return true;
		}
		if (Utilities.isVoid(this.txt_reason_reporting) || this.txt_reason_reporting.length === 0) {
			return false;
		}
		if (this.isBlockingReporting()) {
			return false;
		}
		return !this.needNote() || (this.needNote() && !Utilities.isVoid(this.txt_reason_notes) && this.txt_reason_notes.length > 0);

	}

	isBlockingReporting() {
		return this.txt_reason_reporting === this.getBlockingReporting()[0] || this.txt_reason_reporting === this.getBlockingReporting()[1];
	}

	notifyUpdate() {
		this.updatedStatus.next(true);
	}

	setDateInstallation(date: Date) {
		this.date_installation = DateUtilities.getStringFromDate(date);
		if (!Utilities.isVoid(date)) {
			this.check = 0;
			this.txt_reason_notes = '';
			this.txt_reason_reporting = '';
		} else {
			this.check = 1;
		}
	}

	setDateProvision(date: Date) {
		this.date_provision = DateUtilities.getStringFromDate(date);
	}

	setDateRequest(date: Date) {
		this.date_request = DateUtilities.getStringFromDate(date);
	}

	getDateInstallation(): Date {
		return DateUtilities.getDateFromString(this.date_installation, DateUtilities.onlyDate);
	}

	getDateProvision(): Date {
		return DateUtilities.getDateFromString(this.date_provision, DateUtilities.onlyDate);
	}

	getDateRequest(): Date {
		return DateUtilities.getDateFromString(this.date_request, DateUtilities.onlyDate);
	}

	isChanged(obj: DeliveryChecks) {
		return Utilities.isVoid(obj)
			|| this.txt_reason_reporting !== obj.txt_reason_reporting
			|| this.txt_reason_notes !== obj.txt_reason_notes
			|| this.check !== obj.check
			|| this.date_installation !== obj.date_installation
			|| this.date_provision !== obj.date_provision
			|| this.date_request !== obj.date_request;
	}

	setting(deliveryCheck: DeliveryChecks) {
		this.check = deliveryCheck.check;
		this.txt_reason_notes = deliveryCheck.txt_reason_notes;
		this.txt_reason_reporting = deliveryCheck.txt_reason_reporting;
		if (!Utilities.isVoid(deliveryCheck.date_installation)) {
			this.date_installation = deliveryCheck.date_installation;
		}
		if (!Utilities.isVoid(deliveryCheck.date_provision)) {
			this.date_provision = deliveryCheck.date_provision;
		}
		if (!Utilities.isVoid(deliveryCheck.date_request)) {
			this.date_request = deliveryCheck.date_request;
		}
		this.notifyUpdate();
	}


	getDateAlert() {
		return this.date_alert;
	}

	setDateAlert(date_alert: string) {
		this.date_alert = date_alert;
	}

	getBody(): any {
		return {
			cod_owner: this.cod_owner,
			wd_type: this.wd_type,
			is_aftermarket: this.is_aftermarket,
			id: this.id,
			txt_category: this.txt_category,
			txt_description: this.txt_description,
			txt_more: this.txt_more,
			txt_reason_reporting: (Utilities.isVoid(this.txt_reason_reporting) || this.txt_reason_reporting.length === 0 ? '' : this.txt_reason_reporting),
			txt_reason_notes: (Utilities.isVoid(this.txt_reason_notes) || this.txt_reason_notes.length === 0 ? '' : this.txt_reason_notes),
			check: this.check,
			flag_active: this.flag_active,
			date_installation: (Utilities.isVoid(this.date_installation) || this.date_installation.length === 0 ? '' : this.date_installation),
			date_provision: (Utilities.isVoid(this.date_provision) || this.date_provision.length === 0 ? '' : this.date_provision),
			date_request: (Utilities.isVoid(this.date_request) || this.date_request.length === 0 ? '' : this.date_request),
			cod_factory: this.cod_factory,
			am_net: this.am_net,
			txt_dates_display: this.txt_dates_display,
			flag_updatable_afterreadysp: this.flag_updatable_afterreadysp,
			flag_updatable_afterreadyald: this.flag_updatable_afterreadyald
		};
	}

	getBlockingReporting(locale?: string): string [] {
		return ['Ordinato', 'Ricevuto'];
	}

	needNote(locale?: string): boolean {
		const result = this.txt_reason_reporting === 'Difforme/non compatibile';
		if (!result) {
			this.txt_reason_notes = '';
		}
		return result;
	}
}

